import { TABOO_INSTANCE_FILTER_DIFFICULTY_SELECTED } from "app/games/taboo/reducers/currentUserFilterPerInstance";

export default function difficultySelected(instanceId, difficultyId) {
  return {
    type: TABOO_INSTANCE_FILTER_DIFFICULTY_SELECTED,
    payload: { instanceId, difficultyId },
  }
}
